import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import useAppDispatch from "hooks/useAppDispatch";
import { activateUser } from "../../../../redux/features/auth/authSlice";
import { fetchUser, fetchApp } from "../../../../redux/features/user/userSlice";
import { deleteCookie } from "../../../../utils/cookie";
import { withFromLoginFlag } from "../utils/authRedirect";
import { resetSessionExpiredFlag } from "../../../../helpers/callApi";
import { isLocalhost } from "../../../../utils/appIdStorage";
import { getProjectByAppId } from "../../../../projectConfig/projects";
import {
  getProjectSwitchUrl,
  getCookieDomainFromHostname,
} from "../../../../utils/environment";

export default function useActivationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { code } = useParams();
  const dispatch = useAppDispatch();
  const [activationError, setActivationError] = useState(false);

  useEffect(() => {
    if (!code) {
      setActivationError(true);
      return;
    }

    resetSessionExpiredFlag();

    const cookieDomain =
      getCookieDomainFromHostname() || process.env.REACT_APP_COOKIES || undefined;
    const deleteOpts = cookieDomain ? { domain: cookieDomain } : {};
    deleteCookie("api_key", deleteOpts);
    deleteCookie("API-KEY", deleteOpts);
    deleteCookie("is_manager", deleteOpts);
    deleteCookie("api_key", { path: "/" });
    deleteCookie("API-KEY", { path: "/" });
    deleteCookie("is_manager", { path: "/" });
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem("api_key");
      localStorage.removeItem("API-KEY");
      localStorage.removeItem("is_manager");
    }

    dispatch(activateUser({ code }))
      .then((activationPayload) => {
        const appIdFromActivation =
          activationPayload != null && activationPayload.app_id != null
            ? Number(activationPayload.app_id)
            : null;

        return Promise.all([
          appIdFromActivation != null
            ? Promise.resolve(appIdFromActivation)
            : dispatch(fetchApp()).then((appResult) => {
                const raw =
                  appResult?.app_id != null ? appResult.app_id : appResult;
                return raw != null ? Number(raw) : null;
              }),
          dispatch(fetchUser()),
        ]).then(([appIdResolved]) => {
          const appIdNum = appIdFromActivation ?? appIdResolved;
          if (!isLocalhost() && appIdNum != null && !isNaN(appIdNum)) {
            localStorage.setItem("app_id", String(appIdNum));
            window.dispatchEvent(new Event("appIdChanged"));
          }
          resetSessionExpiredFlag();

          const project =
            appIdNum != null ? getProjectByAppId(appIdNum) : null;
          const projectBaseUrl = getProjectSwitchUrl(appIdNum) ?? project?.href;
          if (projectBaseUrl) {
            const projectHome = projectBaseUrl.replace(/\/$/, "") + "/home";
            window.location.href = withFromLoginFlag(projectHome);
            return;
          }
          navigate("/home");
        });
      })
      .catch(() => {
        setActivationError(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return { t, activationError };
}
